module.exports = __webpack_public_path__ + "img/4-1-north.867f4d9e.jpg";